import React, { Component } from 'react';

class Show extends Component {
  componentDidMount() {
    //this.props.fetchChannels()
  }

  render() {
    return <div>bootsrap html here for editing tag view</div>;
  }
}

export default Show;
